export default __webpack_public_path__ + "static/media/Group 1152.7ac997a6.png";